const commonRouterMap = [
  {
    name: "获取服务所需参数",
    path: "/common/route",
    component: () => import("@/pages/common/route")
  },
  {
    name: "选择国家",
    path: "/common/countries",
    component: () => import("@/pages/common/countries")
  },
  {
    name: "选择民族",
    path: "/common/national",
    component: () => import("@/pages/common/national")
  },
  {
    name: "文章详情",
    path: "/common/article/detail",
    component: () => import("@/pages/common/articledetail")
  },
  {
    name: "",
    path: "/common/cardlist",
    component: () => import("@/pages/common/cardlist")
  },
  {
    name: "登录",
    path: "/common/login",
    component: () => import("@/pages/common/login")
  },
  {
    name: "社区卫生服务中心",
    path: "/common/service",
    component: () => import("@/pages/common/service")
  },
  {
    name: "重要通知",
    path: "/common/policy",
    component: () => import("@/pages/common/policy")
  }
];

export default commonRouterMap;
